'use strict';

module.exports = '<select class="ad-component_select <%= className %>"' +
		'<% if(changeFunction) {%> onchange="<%= changeFunction %>"<%}%>>' +
'<%= list %></select>';



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/ad-select.tpl.js
// module id = 23
// module chunks = 0